import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { StockService } from "../../../services/StockService";
import { AddStockResponse } from "../../../models/response/stock/AddStockResponse";
import { GetStockByIdResponse } from "../../../models/response/stock/GetStockByIdResponse";
import CustomTextInput from "../../../components/CustomTextInput";
import { CompanyService } from "../../../services/CompanyService";
import CustomSwitch from "../../../components/CustomSwitch";
import { useMask } from "@react-input/mask";
import { AddStockRequest } from "../../../models/request/stock/AddStockRequest";
import { GsmStockService } from "../../../services/GsmStockService";
import { DeviceStatusEnum, GsmStatusEnum, InventoryStatusEnum } from "../../../models/common/Enums";
import { GetConstantListResponse, GetConstantListResponseItem } from "../../../models/response/constant/GetConstantListResponse";
import { GetGsmStockByIdResponse } from "../../../models/response/gsmStock/GetGsmStockByIdResponse";
import { AddGsmStockResponse } from "../../../models/response/gsmStock/AddGsmStockResponse";

const StockAdd = () => {
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Cihaz Stok Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [stockId, setStockId] = useState<string | undefined>(undefined);
    const [no, setNo] = useState<string | undefined>(undefined);
    const [mac, setMac] = useState<string | undefined>(undefined);
    const [selectedDeviceBrand, setSelectedDeviceBrand] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeviceBrandDetail, setSelectedDeviceBrandDetail] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [imei, setImei] = useState<string | undefined>(undefined);
    // const [ccid, setCcid] = useState<string | undefined>(undefined);
    // const [plate, setPlate] = useState<string | undefined>(undefined);
    const [isDemo, setIsDemo] = useState<boolean>(false);
    const [softwareVersion, setSoftwareVersion] = useState<string | undefined>(undefined);
    // const [selectedGsmStock, setSelectedGsmStock] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [gsmStatusInStockConstant, setGsmStatusInStockConstant] = useState<GetConstantListResponseItem | undefined>(undefined);
    const [gsmStatusInUseConstant, setGsmStatusInUseConstant] = useState<GetConstantListResponseItem | undefined>(undefined);
    const [selectedInventoryStatus, setSelectedInventoryStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeviceStatus, setSelectedDeviceStatus] = useState<CustomSingleSelectModel | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            var response2: GetConstantListResponse = await ConstantService.getConstantList('GSM_STATUS');

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            setGsmStatusInStockConstant(response2.data.find(x => x.additionalValue1 == GsmStatusEnum.STOKTA));
            setGsmStatusInUseConstant(response2.data.find(x => x.additionalValue1 == GsmStatusEnum.ARACTA_KULLANIMDA));

            var response3: GetConstantListResponse = await ConstantService.getConstantList('INVENTORY_STATUS', undefined, InventoryStatusEnum.STOKTA);

            if (!response3.isSuccess) {
                toast.error(response3.message)
                return;
            }

            var response4: GetConstantListResponse = await ConstantService.getConstantList('DEVICE_STATUS', undefined, DeviceStatusEnum.SIFIR);

            if (!response4.isSuccess) {
                toast.error(response4.message)
                return;
            }

            if (id) {
                var response: GetStockByIdResponse = await StockService.getStockById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setStockId(response.data.stockId);
                setNo(response.data.deviceNo);
                setMac(response.data.macNumber);

                if (response.data.parentDeviceBrandId)
                    setSelectedDeviceBrand({ label: response.data.parentDeviceBrandName, value: response.data.parentDeviceBrandId });

                if (response.data.deviceBrandId)
                    setSelectedDeviceBrandDetail({ label: response.data.deviceBrandName, value: response.data.deviceBrandId });

                setImei(response.data.imei);
                // setCcid(response.data.ccid);

                // if (response.data.companyId)
                //     setSelectedCompany({ label: response.data.companyName, value: response.data.companyId });

                // if (response.data.gsmStockId && response.data.gsmStockName)
                //     setSelectedGsmStock({ label: response.data.gsmStockName, value: response.data.gsmStockId });

                if (response.data.inventoryStatusId && response.data.inventoryStatusName)
                    setSelectedInventoryStatus({ label: response.data.inventoryStatusName, value: response.data.inventoryStatusId });
                else
                    setSelectedInventoryStatus({ label: response3.data[0].value, value: response3.data[0].constantId, additionalValue1: response3.data[0].additionalValue1 });

                if (response.data.deviceStatusId && response.data.deviceStatusName)
                    setSelectedDeviceStatus({ label: response.data.deviceStatusName, value: response.data.deviceStatusId });
                else
                    setSelectedDeviceStatus({ label: response4.data[0].value, value: response4.data[0].constantId, additionalValue1: response4.data[0].additionalValue1 });

                // setPlate(response.data.plate);
                setSoftwareVersion(response.data.softwareVersion);
                setIsDemo(response.data.isDemo);
            }
            else {
                setSelectedInventoryStatus({ label: response3.data[0].value, value: response3.data[0].constantId, additionalValue1: response3.data[0].additionalValue1 });
                setSelectedDeviceStatus({ label: response4.data[0].value, value: response4.data[0].constantId, additionalValue1: response4.data[0].additionalValue1 });
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveStock = async () => {
        try {
            if (!selectedDeviceBrand || !selectedDeviceBrandDetail || Helpers.isEmpty(no) || Helpers.isEmpty(mac)) {
                toast.error('Lütfen boş alan bırakmayınız!')
                return;
            }

            // if (!selectedGsmStock) {
            //     toast.error('Lütfen geçerli bir telefon numarası giriniz!')
            //     return;
            // }

            dispatch(storeActivityIndicator(true));

            var obj: AddStockRequest = {
                stockId: stockId,
                // ccid: ccid,
                // companyId: selectedCompany?.value,
                deviceBrandId: selectedDeviceBrandDetail.value,
                deviceNo: no,
                imei: imei,
                isDemo: isDemo,
                macNumber: mac,
                // plate: plate,
                softwareVersion: softwareVersion,
                // gsmStockId: selectedGsmStock.value,
                inventoryStatusId: selectedInventoryStatus?.value,
                deviceStatusId: selectedDeviceStatus?.value,
            };

            var response: AddStockResponse = await StockService.addStock(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            // var response2: GetGsmStockByIdResponse = await GsmStockService.getGsmStockById(selectedGsmStock.value);

            // if (!response2.isSuccess) {
            //     toast.error(response2.message);
            //     dispatch(storeActivityIndicator(false));
            //     return;
            // }

            // response2.data.gsmStatusId = gsmStatusInUseConstant?.constantId;

            // var response3: AddGsmStockResponse = await GsmStockService.addGsmStock(response2.data);

            // if (!response3.isSuccess) {
            //     toast.error(response3.message);
            //     dispatch(storeActivityIndicator(false));
            //     return;
            // }

            toast.success(response.message)

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Cihaz No</label>
                                        <CustomTextInput value={no} setValue={setNo} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Cihaz Seri No</label>
                                        <CustomTextInput value={mac} setValue={setMac} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Cihaz Marka</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedDeviceBrand}
                                            onChange={(value) => {
                                                setSelectedDeviceBrand(value);
                                                setSelectedDeviceBrandDetail(undefined);
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('DEVICE_BRAND')}
                                            labelName='value'
                                            valueName='constantId'
                                            insertable={{
                                                onSubmit: { code: 'DEVICE_BRAND' }
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Cihaz Model</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedDeviceBrandDetail}
                                            onChange={setSelectedDeviceBrandDetail}
                                            onMenuOpen={() => ConstantService.getConstantList('DEVICE_BRAND_DETAIL', selectedDeviceBrand?.value)}
                                            labelName='value'
                                            valueName='constantId'
                                            insertable={selectedDeviceBrand && {
                                                onSubmit: { code: 'DEVICE_BRAND_DETAIL', parentConstantId: selectedDeviceBrand?.value }
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Cihaz IMEI</label>
                                        <CustomTextInput value={imei} setValue={setImei} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Yazılım Versiyon</label>
                                        <CustomTextInput value={softwareVersion} setValue={setSoftwareVersion} />
                                    </div>

                                    {/* <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">CCID</label>
                                        <CustomTextInput value={ccid} setValue={setCcid} isDisabled />
                                    </div> */}
                                </div>

                                {/* <div className="row mt-5"> */}
                                {/* <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Müşteri</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCompany}
                                            onChange={setSelectedCompany}
                                            onMenuOpen={[
                                                () => CompanyService.getCompanyList({ isCompany: true })
                                            ]}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div> */}

                                {/* <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Plaka</label>
                                        <CustomTextInput value={plate} setValue={setPlate} />
                                    </div> */}

                                {/* <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Sim No</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedGsmStock}
                                            onChange={(value) => {
                                                setSelectedGsmStock(value);
                                                setCcid(value?.additionalValue1 ?? '');
                                            }}
                                            onMenuOpen={() => GsmStockService.getGsmStockList(gsmStatusInStockConstant?.constantId)}
                                            labelName='phone'
                                            valueName='gsmStockId'
                                            additionalValue1Name="iccId"
                                        />
                                    </div> */}
                                {/* </div> */}

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Envanter Durumu</label>

                                        <CustomSingleSelect
                                            disabled
                                            selectedValue={selectedInventoryStatus}
                                            onChange={setSelectedInventoryStatus}
                                            onMenuOpen={() => ConstantService.getConstantList('INVENTORY_STATUS')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Cihaz Durumu</label>

                                        <CustomSingleSelect
                                            disabled
                                            selectedValue={selectedDeviceStatus}
                                            onChange={setSelectedDeviceStatus}
                                            onMenuOpen={() => ConstantService.getConstantList('DEVICE_STATUS')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Demo</label>
                                        <CustomSwitch isActive={isDemo} setIsActive={setIsDemo} />
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveStock}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default StockAdd;